import { storage } from 'lib';

export const INVITE_TOKEN_KEY = 'kf_invite_token';
export const INVITE_IGNORED_KEY = 'kf_invite_ignored';

const InviteService = {
  setInviteToken: (inviteToken: string) => storage.setItem(INVITE_TOKEN_KEY, inviteToken),
  getInviteToken: (): string | null => storage.getItem(INVITE_TOKEN_KEY),
  clearInviteToken: () => storage.removeItem(INVITE_TOKEN_KEY),

  setInviteIgnored: (ignore: boolean) => storage.setItem(INVITE_IGNORED_KEY, JSON.stringify(ignore)),
  getInviteIgnored: (): boolean | null => JSON.parse(storage.getItem(INVITE_IGNORED_KEY)),
  clearInviteIgnored: () => storage.removeItem(INVITE_IGNORED_KEY),
};

export default InviteService;
